var React = require('react');

function EmojiSurprised (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_383","data-name":"Group 383","transform":"translate(-193.257 -559.597)"},React.createElement("path",{"id":"Path_612","data-name":"Path 612","d":"M202.81,569.105a32.438,32.438,0,1,1-9.553,22.947A31.42,31.42,0,0,1,202.81,569.105Zm41.7,4.276a26.331,26.331,0,1,0,7.808,18.671A25.46,25.46,0,0,0,244.514,573.381Zm-24.822,3.053v9.684h-9.684v-9.684Zm-3.009,16.62a12.847,12.847,0,1,1-3.8,9.118A12.431,12.431,0,0,1,216.683,593.054Zm24.908-6.936h-9.684v-9.684h9.684Z","transform":"translate(0 0)","fill":"#161615"})));
}

EmojiSurprised.defaultProps = {"width":"64.997","height":"64.997","viewBox":"0 0 64.997 64.997"};

module.exports = EmojiSurprised;

EmojiSurprised.default = EmojiSurprised;
